import normalizeSearchState from './normalizeSearchState'
import { CustomSearchState } from '@/types/models'
import { getSessionStorageSearchState } from '@/utils/search/searchState'
import removeEmptyKeysAndValues from '@/utils/removeEmptyKeysAndValues'
import { updateRefinementList } from './updateRefinementList'

interface RefineSearchStateByRemovingLocationsAndGeoLoc {
  (): Partial<CustomSearchState>
}

const refineSearchStateByRemovingLocationsAndGeoLoc: RefineSearchStateByRemovingLocationsAndGeoLoc =
  () => {
    const searchState: CustomSearchState = getSessionStorageSearchState() || {}
    const clearedSearchState = removeEmptyKeysAndValues({
      ...searchState,
      aroundLatLng: null,
      locationName: null,
      locationType: null,
      parentLocation: null,
      customLocationRadiusInMiles: null,
      refinementList: {
        ...updateRefinementList({
          refinementList: searchState.refinementList || {},
          updates: {
            locations: []
          }
        })
      },
      configure: removeEmptyKeysAndValues({
        ...searchState.configure,
        aroundLatLng: null,
        aroundRadius: null,
        aroundPrecision: null,
        aroundLatLngViaIP: null
      })
    }) as CustomSearchState

    return normalizeSearchState(clearedSearchState)
  }

export default refineSearchStateByRemovingLocationsAndGeoLoc
